import styled from 'styled-components';
import { Select, Radio } from 'antd';

import { BLACK, WHITE, BORDER_GRAY } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

const RadioGroup = Radio.Group;
const COLOR_8 = '#888';

export const Container = styled.section`
  width: 100%;
  padding: 20px 20px;
  margin: 0 auto;
  margin-top: 30px;

  ${media.tabletP`
    padding: 20px 76px;
    margin-top: 73px;
  `};
`;
export const Title = styled.h1`
  font-size: 20px;
  color: ${BLACK};
  text-align: center;

  ${media.tabletP`
    font-size: 30px;
  `};
`;
export const Hr = styled.div`
  width: 100%;
  height: 1px;
  background: ${BORDER_GRAY.HAIR_BEAUTY_PRO.SETTING};
  margin-top: 0;
  margin-bottom: 20px;

  ${media.tabletP`
    margin-top: ${({ spa }) => (spa ? 0 : '48px')};
    margin-bottom: 60px;
  `};
`;
export const FormItemTitle = styled.div`
  font-size: 16px;
  letter-spacing: 1px;
  color: #000;

  ${media.tabletP`
    font-size: 22px;
  `};
`;
export const TitleDesc = styled.div`
  margin-top: 0px;
  margin-bottom: 20px;
  font-size: 12px;
  line-height: 1.5;
  color: #000;

  ${media.tabletP`
    margin-top: 16px;
    margin-bottom: 46px;
    font-size: 14px;
  `};
`;
export const SelectSection = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .ant-form-item {
    margin-bottom: 0;
  }
  .ant-select {
    width: 160px;
  }

  ${media.tabletP`
    .ant-select {
      width: 300px;
    }
  `};
`;
export const SelectBase = styled(Select)`
  width: 160px;
  .ant-select-selection {
    height: 36px;
    line-height: 36px;
    color: ${COLOR_8};
    font-size: 13px;
    border-radius: 0;
    border: 0;
    border-bottom: 2px solid ${BLACK};
    .ant-select-selection__rendered {
      line-height: 36px;
      margin-right: 0;
      margin-left: 0;
    }
    .ant-select-arrow {
      right: 1px;
    }
    .ant-select-arrow .ant-select-arrow-icon svg {
      color: ${BLACK};
    }
  }
  .ant-select {
    width: 160px;
  }
  .ant-select-dropdown {
    width: 160px;
  }

  ${media.tabletP`
    width: 300px;
    .ant-select-selection {
      font-size: 16px;
    }
    .ant-select {
      width: 300px;
    }
    .ant-select-dropdown {
      width: 300px;
    }
  `};
`;

export const SectionGroupCommon = styled.section`
  .ant-radio-group {
    margin-top: 40px;
  }
`;
export const ACheckboxBase = styled.div`
  .ant-checkbox-wrapper {
    font-size: 16px;
    background-color: #fff;
    padding: 14px 20px;
  }
  .ant-checkbox-checked::after {
    border: none;
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
  }
  .ant-checkbox-inner {
    width: 20px;
    height: 20px;
    border-radius: 0;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #000;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${BLACK};
    border-color: #000;
  }
`;
export const ACheckboxGroupCover = ACheckboxBase.extend`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: row wrap;
  .ant-checkbox-wrapper {
    width: 100%;
    background-color: #fff;
    border: solid 2px #e0e0e0;
    margin-bottom: 12px;
    padding: 14px 20px;
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
  }

  ${media.tabletP`
    .ant-checkbox-wrapper {
      // width: ${({ orientationStr }) => (orientationStr === 'portrait' ? '302px' : '280px')};
      :nth-child(odd) {
        margin-right: 6px;
        width: calc(50% - 6px);
      }
      :nth-child(even) {
        margin-left: 6px;
        width: calc(50% - 6px);
      }
    }
  `};
`;

export const SubmitCover = styled.div`
  margin: 30px auto 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    width: 288px;
    height: 60px;
    background-color: ${BLACK};
    color: ${WHITE};
    border-radius: 0;
    border: none;
    opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
  }

  .ant-btn {
    opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
  }

  .ant-btn:hover,
  .ant-btn:focus,
  .ant-btn:active,
  .ant-btn.active {
    text-decoration: none;
    background-color: ${BLACK};
  }
  .ant-btn:hover,
  .ant-btn:focus {
    color: ${WHITE};
    background-color: ${BLACK};
  }

  ${media.tabletP`
    margin: 80px auto 10px;
  `};
`;
export const SalonMenuGroup = styled.section``;

export const MenuItems = styled.div`
  margin-bottom: 0;

  &.treatmentItems {
    ${media.tabletP`
      margin-bottom: 24px;
    `};
  }
`;

export const SalonItemTitle = styled.div`
  font-size: 14px;
  letter-spacing: 1px;
  color: ${BLACK};
  margin-bottom: 10px;

  ${media.tabletP`
    font-size: 18px;
    margin-bottom: 30px;
  `};
`;

export const SalonMenuSubGroup = ACheckboxBase.extend`
  margin-bottom: 24px;

  ${media.tabletP`
    margin-bottom: 0;
  `};

  .ant-checkbox-wrapper {
    background-color: #fff;
    padding: 0;
    font-size: 13px;
  }

  ${media.tabletP`
    .ant-checkbox-wrapper {
      font-size: 16px;
    }
  `};
`;

/* トリートメント、スパメニュー: メニュー、施術時間、金額、3項目の囲い */
export const MenuItem = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  margin-bottom: 0;

  /* 施術時間、金額入力フォームの囲い */
  > div {
    width: 50%;
    margin-left: 0;
    margin-bottom: 0;
  }

  /* メニュー入力フォームの囲い */
  > div:first-child {
    width: 100%;
    margin-left: 0;
    margin-bottom: 0;
  }

  > div:last-child {
    width: calc(50% - 20px);
    margin-left: 20px;
  }

  /* バリデーションエラー時のスタイル */
  > div {
    .has-error .ant-input {
      border-color: ${({ isChecked }) => (isChecked ? '#f5222d' : '#000')};
    }
  }

  /* バリデーションエラーの文字部分 */
  > div {
    .ant-form-explain {
      font-size: 13px;

      ${media.tabletP`
        font-size: 15px;
      `};
    }
  }

  ${media.tabletP`
    /* 施術時間、金額入力フォームの囲い */
    > div {
      width: calc(25% - 12px);
      margin-left: 12px;
    }

    /* メニュー入力フォームの囲い */
    > div:first-child {
      width: 50%;
      margin-left: 0;
      margin-bottom: 24px;
    }

    > div:last-child {
      width: calc(25% - 12px);
      margin-left: 12px;
    }
  `};
`;

/* トリートメント、スパメニュー: メニュー、施術時間、金額、それぞれの入力フォーム */
export const InputWrapper = styled.div`
  .has-error .ant-input:not([disabled]):hover,
  .has-error .ant-input:focus,
  .ant-input:focus {
    border-bottom-color: #f5222d;
    box-shadow: none;
  }

  /* メニュー、施術時間、金額の入力フォーム */
  .ant-input {
    padding: 10px 0px;
    border: 0;
    border-bottom: 2px solid ${BLACK};
    border-radius: 0;
    font-size: 13px;
    width: 100%;
    height: 100%;
    margin-bottom: 8px;

    ${media.tabletP`
      margin-bottom: 5px;
    `};

    /* 金額の入力フォーム */
    &[name='currency'] {
      padding-left: 14px;
    }
  }
  .ant-input-disabled:hover {
    border-bottom: 2px solid #000;
  }
  .ant-input:hover {
    border-bottom: 2px solid #000;
  }

  ${media.tabletP`
    .ant-input {
      padding: 20px 0px;
      font-size: 16px;
    }
  `};
`;

export const CurrencySymbol = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 0;
  font-size: 13px;
  z-index: 99;

  ${media.tabletP`
    padding: 10px 0px;
    font-size: 16px;
  `};
`;

// TODO: カメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
// export const SectionGroupRadio = styled.section`
//   margin-bottom: 20px;
//   .ant-radio-group {
//     margin-top: 20px;
//   }
//   .ant-form-item-control-wrapper {
//     .has-error .ant-form-explain {
//       margin-top: 8px;
//     }
//   }
//
//   ${media.tabletP`
//     .ant-radio-group {
//       margin-top: 40px;
//     }
//   `};
// `;

// TODO: カメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
// export const RadioWrapper = styled(RadioGroup)`
//   width: 100%;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-flow: row wrap;
//   .ant-radio-wrapper {
//     width: 100%;
//     background-color: #fff;
//     border: solid 2px #e0e0e0;
//     padding: 21px 20px;
//     font-size: 16px;
//     margin-bottom: 15px;
//   }
//   .ant-radio-wrapper.active {
//     border-color: #000;
//     color: #000;
//   }
//   .ant-radio-wrapper:hover .ant-radio,
//   .ant-radio:hover .ant-radio-inner,
//   .ant-radio-input:focus + .ant-radio-inner {
//     border-color: ${BLACK};
//   }
//   .ant-radio-inner::after {
//     background-color: ${BLACK};
//   }
//   input[type='radio'] {
//     width: 20px;
//     height: 20px;
//   }
//
//   ${media.tabletP`
//     .ant-radio-wrapper {
//       // width: ${({ orientationStr }) => (orientationStr === 'portrait' ? '300px' : '300px')};
//       margin-bottom: 0;
//       margin-right: 0;
//       :nth-child(odd) {
//         margin-right: 6px;
//         width: calc(50% - 6px);
//       }
//       :nth-child(even) {
//         margin-left: 6px;
//         width: calc(50% - 6px);
//       }
//     }
//   `};
// `;

export const QA = styled.a`
  display: block;
  text-decoration: underline;
  font-size: 16px;
  color: ${BLACK};
  margin-top: 25px;
  margin-bottom: 20px;

  ${media.tabletP`
    margin-top: 40px;
  `};
`;
export const ErrorMessage = styled.div`
  text-align: ${({ currency }) => (currency ? 'right' : 'center')};
  margin-right: ${({ currency }) => (currency ? '104px' : 0)};
  margin-top: ${({ currency }) => (currency ? '-16px' : 0)};
  color: #f00;
`;
export const BottomMargin = styled.div`
  height: 140px;
`;
export const Spinner = styled.span`
  display: inline-block;
  width: 15px;
  height: 15px;

  ::after {
    content: ' ';
    display: block;
    width: 15px;
    height: 15px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: spinner 1.2s linear infinite;
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

// TODO: カメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
// export const SectionGroupCameraApp = styled.section`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   margin-top: 0;
//   background-color: ${BG_GRAY.COMMON_1};
//   padding-top: 40px;
//   padding-bottom: 40px;
//
//   ${media.tabletP`
//     margin-top: 40px;
//   `};
// `;

// TODO: カメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
// export const DescriptionText = styled.div`
//   font-size: 16px;
//   font-weight: 500;
//   color: ${BLACK};
//   text-align: left;
//   margin: 0 20px;
//   white-space: pre-line;
//
//   ${media.tabletP`
//     text-align: center;
//   `};
// `;

// TODO: カメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
// export const ManualLink = styled.div`
//   font-size: 16px;
//   font-weight: 500;
//   color: ${BLACK};
//   text-align: center;
//   text-decoration: underline;
//   cursor: pointer;
// `;

// TODO: カメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
// export const ButtonWrapper = styled.div`
//   display: flex;
//   width: 100%;
//   justify-content: center;
//   > a {
//     display: inline-block;
//     width: 100%;
//     max-width: 288px;
//     margin: 0 20px;
//   }
// `;

// TODO: カメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
// export const DLButton = styled.div`
//   position: relative;
//   display: flex;
//   align-items: center;
//   justify-content: flex-start;
//   width: 100%;
//   height: 60px;
//   margin: 20px 0;
//   padding: 0 20px 0 55px;
//   background-color: ${BLACK};
//   color: ${WHITE};
//   cursor: pointer;
// `;

export const ModalContent = styled.div`
  position: absolute;
  top: calc(50% + 30px);
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 728px;
  background-color: ${WHITE};
  box-shadow: 0px 10px 28.2px 1.8px rgba(0, 0, 0, 0.2);
`;
export const ModalBody = styled.div`
  max-height: 75vh;
  padding: 0 80px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
`;
export const ModalFooter = styled.div`
  border-top: solid 1px ${BORDER_GRAY.COMMON_2};
  text-align: center;
  cursor: pointer;
  color: ${BLACK};
  font-size: 14px;
  padding: 30px 0;
  text-align: center;
  background-color: ${WHITE};
  > div {
    position: relative;
    display: inline-block;
    &:after,
    &:before {
      position: absolute;
      top: 48%;
      left: -25px;
      transform: translateY(-50%) rotate(45deg);
      content: '';
      display: block;
      width: 15px;
      height: 1px;
      background: ${BLACK};
    }

    &:after {
      transform: translateY(-50%) rotate(-45deg);
    }
  }
`;

// TODO: カメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
// export const DownloadSvg = styled.img`
//   position: absolute;
//   left: 20px;
//   top: 50%;
//   transform: translateY(-50%);
// `;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SettingPage/SettingPage.style.js